import React from 'react'
import { useDidUpdate } from 'rooks'
import { Navigate, useNavigate } from 'react-router-dom'
import { useAppSelector } from 'store/hooks'

import Grid from '@material-ui/core/Grid'
import Button from 'components/Shared/Button/Button'

import AddProductContainer from 'containers/ProductsAndCategories/AddProductContainer/AddProductContainer'

import { selectActiveWorkspace } from 'lib/helpers/selectors'
import { ROUTES } from '../../../constants'

import Clear from '@material-ui/icons/Clear'
import './style.scss'

interface Props {}

const AddProductScreen: React.FC<Props> = props => {
  const navigate = useNavigate()
  const workspaceId = useAppSelector(selectActiveWorkspace)

  // Temporal a HOME, en su momento debera redirigir a INVOICES.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useDidUpdate(() => {
    onRouteChange('cancel')
  }, [workspaceId])

  const onRouteChange = (action: string, id: number = 0) => {
    if (action === 'error')
      navigate(ROUTES.CATEGORIES_PRODUCTS, { replace: true })
    if (action === 'cancel' || action === 'success')
      navigate(ROUTES.CATEGORIES_PRODUCTS)
  }

  if (!workspaceId) {
    return <Navigate to={ROUTES.HOME} replace />
  }

  return (
    <>
      <Grid container spacing={0} className="screen-products-services">
        <Grid item xs={12}>
          <div className="title-container">
            <h1>Agregar nuevo producto o servicio</h1>
            <Button
              id="cancelNewProductBtn"
              variant="hover"
              color="secondary"
              startIcon={<Clear />}
              onClick={() => onRouteChange('cancel')}>
              Cancelar
            </Button>
          </div>
        </Grid>
        <Grid item xs={12}>
          <AddProductContainer
            workspaceId={workspaceId}
            onRedirect={onRouteChange}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default AddProductScreen
